//librerias
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-modal-validacion",
  templateUrl: "./modal-validacion.component.html",
  styleUrls: ["./modal-validacion.component.css"],
})
export class ModalValidacionComponent {
  @Input() mensaje!: string;
  @Input() valor!: string;
  @Input() flagEncontrado!: boolean;
  @Output() Confirm = new EventEmitter();
  @Output() Cancel = new EventEmitter();

  inputValue: string = "";

  confirm() {
    this.Confirm.emit();
  }

  cancel() {
    this.Cancel.emit();
  }

  isInputValueValid(): boolean {
    return this.inputValue === this.valor;
  }
}
